var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_2901_16084)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5556 3C9.83361 3 9.1412 3.30728 8.63069 3.85425C8.12017 4.40122 7.83337 5.14306 7.83337 5.91659V10.1945C7.83337 10.968 8.12017 11.7099 8.63069 12.2568C9.1412 12.8038 9.83361 13.1111 10.5556 13.1111C11.2776 13.1111 11.97 12.8038 12.4805 12.2568C12.991 11.7099 13.2778 10.968 13.2778 10.1945V5.91659C13.2778 5.14306 12.991 4.40122 12.4805 3.85425C11.97 3.30728 11.2776 3 10.5556 3ZM12.3704 10.1945C12.3704 10.7102 12.1792 11.2048 11.8389 11.5694C11.4985 11.934 11.0369 12.1389 10.5556 12.1389C10.0743 12.1389 9.61266 11.934 9.27232 11.5694C8.93198 11.2048 8.74077 10.7102 8.74077 10.1945V5.91659C8.74077 5.40091 8.93198 4.90634 9.27232 4.5417C9.61266 4.17705 10.0743 3.9722 10.5556 3.9722C11.0369 3.9722 11.4985 4.17705 11.8389 4.5417C12.1792 4.90634 12.3704 5.40091 12.3704 5.91659V10.1945Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3704 10.1945C12.3704 10.7102 12.1792 11.2048 11.8389 11.5694C11.4985 11.934 11.0369 12.1389 10.5556 12.1389C10.0743 12.1389 9.61266 11.934 9.27232 11.5694C8.93198 11.2048 8.74077 10.7102 8.74077 10.1945V5.91659C8.74077 5.40091 8.93198 4.90634 9.27232 4.5417C9.61266 4.17705 10.0743 3.9722 10.5556 3.9722C11.0369 3.9722 11.4985 4.17705 11.8389 4.5417C12.1792 4.90634 12.3704 5.40091 12.3704 5.91659V10.1945Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0638 17V15.1125C7.50628 14.8836 5.50015 12.8871 5.50015 10.4656C5.49854 10.4051 5.51006 10.3448 5.53404 10.2884C5.55802 10.232 5.59397 10.1806 5.63978 10.1373C5.68559 10.0939 5.74033 10.0595 5.80077 10.0359C5.86122 10.0124 5.92615 10.0003 5.99174 10.0003C6.05733 10.0003 6.12226 10.0124 6.18271 10.0359C6.24315 10.0595 6.29789 10.0939 6.3437 10.1373C6.38951 10.1806 6.42546 10.232 6.44944 10.2884C6.47342 10.3448 6.48494 10.4051 6.48333 10.4656C6.48333 12.5395 8.31022 14.2266 10.5555 14.2266C12.8009 14.2266 14.6278 12.5392 14.6278 10.4654C14.6261 10.4048 14.6377 10.3445 14.6617 10.2881C14.6856 10.2318 14.7216 10.1804 14.7674 10.137C14.8132 10.0936 14.8679 10.0592 14.9284 10.0357C14.9888 10.0121 15.0538 10 15.1194 10C15.1849 10 15.2499 10.0121 15.3103 10.0357C15.3708 10.0592 15.4255 10.0936 15.4713 10.137C15.5171 10.1804 15.5531 10.2318 15.5771 10.2881C15.601 10.3445 15.6126 10.4048 15.6109 10.4654C15.6109 12.8868 13.6051 14.8834 11.0473 15.1125V17H10.0638Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2901_16084",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerActive);
export default __webpack_public_path__ + "static/media/speaker_active.ae2c57cb38e8d6a24aa0fa79ca1f9288.svg";
export { ForwardRef as ReactComponent };